// Runtime config wins: env-config.js assigns window._env_ before the bundle
// loads (build-env.js in dev, env.sh in the container), and that is where
// every deployed value actually comes from. Unchanged by the Vite move.
//
// The build-time fallbacks behind it did change. react-scripts substituted
// `process.env` wholesale at build time, so a dynamic `process.env[key]`
// worked in the browser. Vite does not define `process`, so those reads
// would now throw "process is not defined". `import.meta.env` is the
// equivalent, and VITE_ replaces REACT_APP_ as the exposed prefix.
//
// NODE_ENV has no import.meta.env counterpart. Vite exposes the build mode
// as MODE, which carries exactly the values react-scripts put in NODE_ENV:
// "production" for a production build, "development" under the dev server,
// "test" under vitest. index.tsx gates Sentry init on getEnv("NODE_ENV"),
// so this mapping is load-bearing.
const getEnv = (key = "") => {
  if (key === "NODE_ENV") {
    return window._env_[key] ?? import.meta.env.MODE;
  }

  return (
    window._env_[key] ??
    import.meta.env[key] ??
    import.meta.env[`VITE_${key}`] ??
    // Transitional: vite.config.ts still exposes the REACT_APP_ prefix so
    // an existing local .env keeps working. Drop once those are renamed.
    import.meta.env[`REACT_APP_${key}`]
  );
};

export default getEnv;
